import React from 'react';
import Typography from './Typography';
import { Button } from './UI/Button';
import { useNavigate } from 'react-router-dom';
import { Flex } from './UI/Flex';
import { ReactComponent as AlertIcon } from '../assets/icons/mevo/ic_alert.svg';

export default function PrescriberUpdateDataWarning() {
  const navigate = useNavigate();

  return (
    <Flex justifyContent={'center'} align={'center'}>
      <Flex
        bg={'surface'}
        position={'relative'}
        w={'100%'}
        borderRadius={'20px'}
        boxShadow={'3px 3px 10px rgba(61, 14, 107, 0.1)'}
        flexDir={'column'}
        justifyContent={'center'}
        alignItems={'center'}
        padding={'20px'}
        gap={'15px'}
        maxW={'400px'}
      >
        <AlertIcon width={100} height={100} />
        <Typography model="h1" weight="bold" textAlign={'center'}>
          Sua conta precisa de atualização!
        </Typography>
        <Typography model="h3" weight="regular" textAlign={'justify'}>
          Identificamos a necessidade de revisar algumas informações em seu cadastro. Por isso, não será possível
          iniciar uma nova prescrição até que tudo esteja regularizado. Pedimos que confira seus dados cadastrais e
          clique em 'Salvar' para concluir a atualização.
        </Typography>
        <Button onClick={() => navigate('/inicio/meus-dados')} variant={'solid'} w={'100%'} h={'60px'}>
          Atualizar Cadastro
        </Button>
      </Flex>
    </Flex>
  );
}
